import * as React from "react";
const SvgFiRrIssueLoupe = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-issue-loupe_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-5.963-5.963a9.95 9.95 0 0 0 2.262-6.324c0-5.514-4.486-10-10-10s-10 4.486-10 10 4.486 10 10 10c2.398 0 4.6-.85 6.324-2.262l5.963 5.963a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414m-21.7-12.287c0-4.41 3.588-8 8-8 4.41 0 8 3.59 8 8s-3.59 8-8 8c-4.412 0-8-3.589-8-8M11.5 14.5A1.5 1.5 0 1 1 8.5 14.5a1.5 1.5 0 0 1 3.001.001M13 7a2.99 2.99 0 0 1-1.62 2.665c-.175.09-.305.287-.356.538q-.023.111-.023.227v.571a1 1 0 1 1-2 0v-.57q0-.322.065-.634c.174-.842.682-1.538 1.393-1.907a1 1 0 1 1-3.458-.889c0-1.654 1.346-3 3-3s3 1.346 3 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-issue-loupe_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrIssueLoupe;
